import criticalAlertSound from 'src/assets/sounds/critical_alert.mp3'
import urgentMessageSound from 'src/assets/sounds/urgent_message.mp3'
import { NotificationSoundKey } from 'src/interfaces/notificationPreferences'

const notificationSoundSources: Record<NotificationSoundKey, string> = {
  [NotificationSoundKey.CriticalAlert]: criticalAlertSound,
  [NotificationSoundKey.UrgentMessage]: urgentMessageSound,
}

const activeAudio = new Map<NotificationSoundKey, HTMLAudioElement>()

function getAudio(soundKey: NotificationSoundKey): HTMLAudioElement | null {
  if (typeof Audio === 'undefined') {
    return null
  }

  const existingAudio = activeAudio.get(soundKey)
  if (existingAudio) {
    return existingAudio
  }

  const audio = new Audio(notificationSoundSources[soundKey])
  audio.preload = 'auto'
  activeAudio.set(soundKey, audio)

  return audio
}

export async function playNotificationSound(
  soundKey: NotificationSoundKey,
): Promise<void> {
  const audio = getAudio(soundKey)
  if (!audio) {
    return
  }

  audio.pause()
  audio.currentTime = 0

  try {
    await audio.play()
  } catch (error) {
    if (process.env.DEV) {
      console.warn('[NotificationSounds] Unable to play sound:', error)
    }
  }
}
